import { render } from "./z-complete-master-task-modal.vue?vue&type=template&id=97318966"
import script from "./z-complete-master-task-modal.vue?vue&type=script&lang=js"
export * from "./z-complete-master-task-modal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__